import { render, staticRenderFns } from "./Grid4.vue?vue&type=template&id=05150cc2&scoped=true"
import script from "./Grid4.vue?vue&type=script&lang=ts"
export * from "./Grid4.vue?vue&type=script&lang=ts"
import style0 from "./Grid4.vue?vue&type=style&index=0&id=05150cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05150cc2",
  null
  
)

export default component.exports